function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import * as c from './constants';
var initialState = {
  emailVerification: {
    email: null,
    expired: false,
    required: false
  },
  loginCode: null,
  qrCodeUrl: null,
  redirect: null,
  status: {
    loading: true,
    processing: false
  }
};
export var getOtherLocalizationLogoutLinks = createSelector(function (_ref) {
  var application = _ref.application;
  return application.localizations;
}, function (_ref2) {
  var application = _ref2.application;
  return application.currentLocalization;
}, function (localizations, currentLocalization) {
  return localizations.filter(function (localization) {
    return localization.identity !== currentLocalization.identity;
  }).map(function (_ref3) {
    var secureSite = _ref3.secureSite;
    return "https://".concat(secureSite, "/api/auth/logout.gif");
  });
});
export var getInitialFormData = createSelector(function (_ref4) {
  var match = _ref4.match;
  return match.params;
}, function (params) {
  try {
    return typeof params.data !== 'undefined' ? JSON.parse(atob(decodeURIComponent(params.data))) : null;
  } catch (error) {
    return {
      error: error
    };
  }
});
export var getReferringUrl = createSelector(function (_ref5) {
  var location = _ref5.location;
  return location.search;
}, function (search) {
  var matches = search.match(/.*redirect=([^&]*)/);
  return matches && matches.length === 2 ? matches[1] : null;
});
export var getLoginMessage = createSelector(getReferringUrl, function (referringUrl) {
  if (/digital-editing\/free-trial/.test(referringUrl)) {
    return 'digital-editing-login-message';
  }
  if (/digital-translations/.test(referringUrl)) {
    return 'digital-translations-login-message';
  }
  return '';
});

/**
 * Set by Megatron when it redirects here after a verification link was followed.
 * @see AuthenticationController::verifyEmailAction
 */
export var getEmailVerificationOutcome = createSelector(function (_ref6) {
  var location = _ref6.location;
  return location.search;
}, function (search) {
  return new URLSearchParams(search).get('emailVerification');
});
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.USER_LOGIN_REQUESTED:
    case c.USER_PASSWORD_RESET_REQUESTED:
    case c.USER_REGISTRATION_REQUESTED:
    case c.USER_RESET_PASSWORD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        processing: true
      });
    case c.USER_EMAIL_VERIFICATION_REQUIRED:
    case c.USER_LOGIN_ATTEMPT_COMPLETED:
    case c.USER_PASSWORD_RESET_REQUEST_COMPLETED:
    case c.USER_REGISTRATION_REQUEST_FAILED:
    case c.USER_RESET_PASSWORD_REQUEST_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        processing: false
      });
    case c.QR_CODE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case c.QR_CODE_RETRIEVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });
    default:
      return state;
  }
};
export var authenticationReducer = function authenticationReducer() {
  var _action$email;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.USER_LOGIN_ATTEMPT_COMPLETED:
    case c.USER_LOGIN_REQUESTED:
    case c.USER_PASSWORD_RESET_REQUEST_COMPLETED:
    case c.USER_PASSWORD_RESET_REQUESTED:
    case c.USER_REGISTRATION_REQUEST_FAILED:
    case c.USER_REGISTRATION_REQUESTED:
    case c.USER_RESET_PASSWORD_REQUEST_COMPLETED:
    case c.USER_RESET_PASSWORD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.USER_EMAIL_VERIFICATION_REQUIRED:
      return _objectSpread(_objectSpread({}, state), {}, {
        emailVerification: {
          email: (_action$email = action.email) !== null && _action$email !== void 0 ? _action$email : null,
          expired: Boolean(action.expired),
          required: true
        },
        status: status(state.status, action)
      });
    case c.WECHAT_REDIRECT_RECEIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        redirect: action.redirectUri
      });
    case c.QR_CODE_RETRIEVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loginCode: action.loginCode,
        qrCodeUrl: action.qrCodeUrl,
        status: status(state.status, action)
      });
    default:
      return state;
  }
};